import React, { FC, HTMLAttributes } from 'react'
import { useRouter } from 'next/router'

import BasicHeadSeo from '@/components/basicHeadSeo'
import Footer from '@/components/newFooter/newFooter'
import Header from '@/components/newHeader/Header'

import s from './PageLayout.module.scss'

interface PageLayoutProps extends HTMLAttributes<HTMLDivElement> {}

interface Layout extends PageLayoutProps {
  title?: string
  description?: string
  url?: string
  content?: string
  hero?: React.ReactNode
}

const PageLayout: FC<Layout> = ({
  children,
  title,
  description,
  url,
  content,
  hero,
}) => {
  const router = useRouter()
  const path = router.asPath
  return (
    <div>
      <BasicHeadSeo
        title={title ? `${title} - MawooPets.com` : 'MawooPets.com'}
        description={description}
        url={url || process.env.NEXT_PUBLIC_ROOT_URL + path}
        content={content}
      />
      <Header />
      {hero ? hero : null}
      <section className={s.section}>{children}</section>
      <Footer />
    </div>
  )
}

export default PageLayout
